import React from 'react';
import { FieldRenderProps } from '@progress/kendo-react-form';
import { GearFieldWrapper } from '../GearFieldWrapper';
import { ComboBox, ComboBoxChangeEvent, ComboBoxFilterChangeEvent } from '@progress/kendo-react-dropdowns';

interface FormComboBoxProps extends FieldRenderProps {
  onFilterChange?: (value: string) => void;
  onSelectionChange?: (value: any) => void;
}

export const FormComboBox: React.FC<FormComboBoxProps> = fieldRenderProps => {
  const { defaultValue, value, choices, name, disabled, onFilterChange, onSelectionChange } = fieldRenderProps;

  if (!name) {
    return <></>;
  }

  const handleFilterChange = (event: ComboBoxFilterChangeEvent) => {
    if (onFilterChange) {
      onFilterChange(event.filter.value);
    }
  };

  const handleChange = (event: ComboBoxChangeEvent) => {
    if (onSelectionChange) {
      onSelectionChange(event.target.value);
    }
  };

  return (
    <GearFieldWrapper {...fieldRenderProps}>
      <ComboBox
        data={choices || []}
        value={value || defaultValue || null}
        onChange={handleChange}
        onFilterChange={handleFilterChange}
        filterable={true}
        allowCustom={false}
        id={fieldRenderProps.name.toString()}
        validationMessage={fieldRenderProps.validationMessage || undefined}
        disabled={disabled}
      />
    </GearFieldWrapper>
  );
};
